import { useEffect } from 'react';
const ELEVAR_CONFIG_URL = 'https://shopify-gtm-suite.getelevar.com/configs/10011c2a7c95d90f2302e21614dccc9d7606207a/config.js';
const ELEVAR_SCRIPT_ID = 'elevar-custom-pages';
/**
 * Loads Elevar's custom-pages tracking script.
 *
 * Elevar ships this as an inline `<script type="module">` for the document
 * head. Because this project has no editable index.html, the same module is
 * injected at runtime — a dynamically created inline module script executes
 * identically to one authored in the HTML.
 *
 * The script installs once per page load and is never removed: Elevar attaches
 * global listeners, so tearing the tag out would not unload it.
 */
export function useElevar(enabled: boolean): void {
  useEffect(() => {
    if (!enabled || typeof document === 'undefined') {
      return;
    }
    if (document.getElementById(ELEVAR_SCRIPT_ID)) {
      return;
    }
    const script = document.createElement('script');
    script.id = ELEVAR_SCRIPT_ID;
    script.type = 'module';
    script.textContent = `
      try {
        const settings = {};
        const config = (await import("${ELEVAR_CONFIG_URL}")).default;
        const scriptUrl = settings.proxyPath
          ? settings.proxyPath + config.script_src_custom_pages_proxied
          : config.script_src_custom_pages;
        if (scriptUrl) {
          const { handler } = await import(scriptUrl);
          await handler(config, settings);
        }
      } catch (error) {
        console.error('Elevar tracking error:', error);
      }
    `;
    document.head.appendChild(script);
  }, [enabled]);
}
